// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"7796fbe2","738":"7796fbe2","826":"7796fbe2"}[chunkId] + ".chunk.css";
};